interface Params {
  fixSize?: number;
  maxRadius?: number;
  maxY?: number;
  minRadius?: number;
  minY?: number;
  value?: number;
}

export const calcPlotRadius = ({
  fixSize,
  maxRadius = 30,
  maxY = 0,
  minRadius = 6,
  minY = 0,
  value = 0,
}: Params): number => {
  if (!value) {
    return 0;
  } else if (fixSize) {
    return fixSize;
  }

  if (minY === maxY) {
    // Avoid division by zero if all y values are the same
    return (minRadius + maxRadius) / 2;
  }

  // Linear scaling: maps y from [minY, maxY] to radius in [minRadius, maxRadius]
  const scale = (value - minY) / (maxY - minY);
  return minRadius + scale * (maxRadius - minRadius);
};
